import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PropertyFactory from "../../Entity/Factories/PropertyFactory";

export default function* propertyForPropertyDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `properties/${action.payload?.propertyId}`);

    const property = PropertyFactory.create(res.data.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, property);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPropertyForPropertyDetailsPage() {
  yield takeEvery(Constants.GLOBAL_PROPERTY_FOR_PROPERTY_DETAILS_PAGE, propertyForPropertyDetailsPage);
}
